module.exports = __webpack_public_path__ + "img/fs2.40a3367b.gif";